import { UserRole } from '../services/users';

export interface NavigationItem {
  name: string;
  href: string;
  icon: any;
  requiredRoles?: UserRole[];
}

export const hasPermission = (userRole: UserRole, requiredRoles?: UserRole[]): boolean => {
  // Se não há roles requeridas, todos têm acesso
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  // ADMINISTRATOR sempre tem acesso a tudo
  if (userRole === UserRole.ADMINISTRATOR) {
    return true;
  }

  // Para outras roles, verifica se está na lista de roles permitidas
  return requiredRoles.includes(userRole);
};

export const filterNavigationByRole = (navigation: NavigationItem[], userRole: UserRole): NavigationItem[] => {
  return navigation.filter(item => hasPermission(userRole, item.requiredRoles));
};
